<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog">
        <el-form ref="formValidate" :model="model" :rules="rules" label-width="120px">
            <el-form-item label="户用id：" prop="member_id">
                <el-input v-model="model.member_id"></el-input>
            </el-form-item>
            <el-form-item label="CarId：" prop="car_id">
                <el-input v-model="model.car_id"></el-input>
            </el-form-item>
            <el-form-item label="用户唯一标识（用于核验用户身份）：" prop="car_code">
                <el-input v-model="model.car_code"></el-input>
            </el-form-item>
            <el-form-item label="VehicleId：" prop="vehicle_id">
                <el-input v-model="model.vehicle_id"></el-input>
            </el-form-item>
            <el-form-item label="vin标识码：" prop="vin">
                <el-input v-model="model.vin"></el-input>
            </el-form-item>
            <el-form-item label="车辆类型(3/y 以及车辆型号）：" prop="car_type">
                <el-input v-model="model.car_type"></el-input>
            </el-form-item>
            <el-form-item label="辆车颜色：" prop="car_color">
                <el-input v-model="model.car_color"></el-input>
            </el-form-item>
            <el-form-item label="电池容量（最新容量）位单度：" prop="battery_capacity">
                <el-input v-model="model.battery_capacity"></el-input>
            </el-form-item>
            <el-form-item label="最大功率（车辆参数）：" prop="power">
                <el-input v-model="model.power"></el-input>
            </el-form-item>
            <el-form-item label="车辆状态(1,asleep;2,online)：" prop="state">
                <el-input v-model="model.state"></el-input>
            </el-form-item>
            <el-form-item label="车辆昵称：" prop="display_name">
                <el-input v-model="model.display_name"></el-input>
            </el-form-item>
            <el-form-item label="经度：" prop="lon">
                <el-input v-model="model.lon"></el-input>
            </el-form-item>
            <el-form-item label="纬度：" prop="lat">
                <el-input v-model="model.lat"></el-input>
            </el-form-item>
            <el-form-item label="剩余电量（单位度）：" prop="soc">
                <el-input v-model="model.soc"></el-input>
            </el-form-item>
            <el-form-item label="当前剩余里程（单位公里）：" prop="odometer">
                <el-input v-model="model.odometer"></el-input>
            </el-form-item>
            <el-form-item label="当前总里程（单位公里）：" prop="sum_odometer">
                <el-input v-model="model.sum_odometer"></el-input>
            </el-form-item>
            <el-form-item label="版本：" prop="version">
                <el-input v-model="model.version"></el-input>
            </el-form-item>
            <el-form-item label="车外温度（单位 摄氏度）：" prop="outside_temp">
                <el-input v-model="model.outside_temp"></el-input>
            </el-form-item>
            <el-form-item label="内车温度（单位 摄氏度）：" prop="inside_temp">
                <el-input v-model="model.inside_temp"></el-input>
            </el-form-item>
            <el-form-item label="创建时间：" prop="create_time">
                <el-input v-model="model.create_time"></el-input>
            </el-form-item>
            <el-form-item label="更新时间：" prop="update_time">
                <el-input v-model="model.update_time"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialog" size="medium">取 消</el-button>
            <el-button type="primary" @click="handleSubmit" size="medium">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'

export default {
    name: 'carInfoEdit',
    mixins: [editutil],
    data() {
        return {
            model: {
                member_id: '',
                car_id: '',
                car_code: '',
                vehicle_id: '',
                vin: '',
                car_type: '',
                car_color: '',
                battery_capacity: '',
                power: '',
                state: '',
                display_name: '',
                lon: '',
                lat: '',
                soc: '',
                odometer: '',
                sum_odometer: '',
                version: '',
                outside_temp: '',
                inside_temp: '',
                create_time: '',
                update_time: '',
            },
            getObj:{
                url:'/api/admin/carinfo/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: [],
            rules: {
                xxxname: [
                    {required: true, message: 'xxx名称不能为空', trigger: 'blur'}
                ],
            }
        };
    },
    methods: {
        //保存方法
        handleSubmit() {
            this.$refs[this.form_name].validate((valid) => {
                if (valid) {
                    this.formatModel();
                    let config = {
                        url:'/api/admin/carinfo/save'
                    }
                    config["data"] = this.model;
                    saveModel(config).then(res=>{
                        if(res.code===1){
                            this.$msgs("保存成功！");
                            this.$emit("on-save-ok",{});
                        }else{
                            this.$msg(res.msg)
                        }
                    }).catch();
                }
            })
        },
    }
};
</script>